import { useState } from 'react';
import { motion, useScroll, useSpring, useMotionValueEvent } from 'framer-motion';

const ScrollProgress = () => {
  const { scrollYProgress, scrollY } = useScroll();
  const [isVisible, setIsVisible] = useState(true);
  const [lastScrollY, setLastScrollY] = useState(0);
  const [isAtBottom, setIsAtBottom] = useState(false);
  
  const scaleX = useSpring(scrollYProgress, {
    stiffness: 100,
    damping: 30,
    restDelta: 0.001
  });

  useMotionValueEvent(scrollY, "change", (latest) => {
    const direction = latest > lastScrollY ? "down" : "up";
    
    if (latest < 100) {
      setIsVisible(true);
    } else {
      setIsVisible(direction === "down");
    }
    
    setLastScrollY(latest);
  });

  useMotionValueEvent(scrollYProgress, "change", (latest) => {
    setIsAtBottom(latest > 0.95);
  });

  return (
    <motion.div
      initial={{ opacity: 1 }}
      animate={{ opacity: isVisible ? 1 : 0 }}
      transition={{ duration: 0.2, ease: 'easeOut' }}
      className="fixed top-0 left-0 right-0 z-[100] h-[2px] origin-left pointer-events-none"
      style={{ 
        scaleX,
        background: 'linear-gradient(90deg, hsl(var(--gold-dark)) 0%, hsl(var(--gold)) 50%, hsl(var(--gold-light)) 100%)',
      }}
    />
  );
};

export default ScrollProgress;
